import { render, staticRenderFns } from "./DocumentsTableComponent.vue?vue&type=template&id=2f02c22c&scoped=true&"
import script from "./DocumentsTableComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentsTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTableComponent.vue?vue&type=style&index=0&id=2f02c22c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f02c22c",
  null
  
)

export default component.exports